import * as next from 'next'

import { Template, TemplateProps } from '@bob/about'

import * as core from '@bob/services'
import { defaultLocale } from '@owl-nest/cold-data'

export async function getStaticProps({
  locale = defaultLocale.code,
  params,
}: next.GetStaticPropsContext<Path['params']>): Promise<next.GetStaticPropsResult<TemplateProps>> {
  if (!params?.slug) {
    return {
      notFound: true,
    }
  }

  const data = await core.about.build.get({ slug: params.slug, locale })

  if (!data) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      data,
    },
  }
}

type Path = {
  params: { slug: string }
  locale: string
}
export async function getStaticPaths({ locales = [] }: next.GetStaticPathsContext): Promise<next.GetStaticPathsResult> {
  const paths: Path[] = []

  await Promise.all(
    locales.map(async (locale) => {
      if (locale !== 'fr') {
        return
      }

      const collection = await core.about.build.getPartialCollection({
        locale,
        limit: 100,
        skip: 0,
      })
      if (collection) {
        for (const slug of collection) {
          paths.push({
            params: { slug },
            locale,
          })
        }
      }
    }),
  )

  return {
    paths,
    fallback: false,
  }
}

export default Template
